import React from 'react';
import { connect } from 'react-redux';
import Header from '../layout/Header';
import Message from '../layout/Message';
import Button from '../layout/Button';
import FormField from '../layout/FormField';
import {
    validateUser,
    LOGIN_USER_MODIFIED,
    LOGIN_PASSWORD_MODIFIED,
} from '../../actions/LoginActions';

import {
    validateForm,
    checkForChanges,
} from '../../utilities/validate';

const mapStateToProps = state => ({
    pianoTechUser: state.pianoTechUser,
    user: state.user,
});

class Login extends React.PureComponent {

    loginUser = () => {
        const { userid, password } = this.props.user;
        this.props.dispatch(validateUser(userid, password));
    }

    onChange = (event) => {
        const { name, value } = event.target;
        this.props.dispatch({
            type: name === 'userid' ? LOGIN_USER_MODIFIED : LOGIN_PASSWORD_MODIFIED,
            payload: {
                [name]: value,
            }
        });
    }

    render() {
        const { userid, password } = this.props.user;
        const { error, validatingUser } = this.props.user;

        return (
            <div className="divMedium" align="center">
                <Header header2={this.props.user.title} />
                <Message message={this.props.user.message}
                    type={this.props.user.messageType} />
                <br />
                <table className='tableMedium'>
                    <tbody>
                        <FormField row form={{ title: 'User ID', type: 'textinput', length: '50', maxLength: '50' }}
                            name="userid"
                            value={userid}
                            onChange={this.onChange}
                        />
                        <FormField row form={{ title: 'Password', type: 'password', length: '20', maxLength: '20' }}
                            name="password"
                            value={password}
                            onChange={this.onChange}
                        />
                        <tr>
                            <td>
                                <Button className="bluebutton-wide" description="Login" onClick={this.loginUser} disabled={validatingUser} />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        )
    }
}

export default connect(mapStateToProps)(Login);
